"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const getCourseEnrollments_1 = require("./getCourseEnrollments");
function getUsers({ courseId, role = identifiers_1.Types.UserPermissionRoles.STUDENT, userId, email, uid, domainId, courseWorkId }) {
    return __awaiter(this, void 0, void 0, function* () {
        const usersRef = app_1.app.firestore.collection('users');
        if (userId) {
            try {
                const userDoc = yield getUserDocUsingUserId(usersRef, userId);
                if (userDoc.exists) {
                    return [userDoc];
                }
                else {
                    return [];
                }
            }
            catch (e) {
                throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, 'Error fetching student info from student id ' + userId, e.message);
            }
        }
        else if (uid && domainId) {
            const domainsRef = yield getUserDocUsingUserId(usersRef, uid);
            const doc = yield domainsRef.get();
            if (doc.exists) {
                const data = doc.data();
                // check in permissions, if domainId === permission.id
                const domainCheck = data.permissions.filter(permission => domainId === permission.domainId);
                if (domainCheck.length) {
                    return [Object.assign({}, data, { id: doc.id })];
                }
                else {
                    return [];
                }
            }
            else {
                console.log(`No user document exists with given domainId and uid. Values - domainId : ${domainId}, uid: ${uid}`);
                return [];
            }
        }
        else if (courseId) {
            return yield getUserDocUsingCourseId(usersRef, courseId, role, {
                email
            });
        }
        else if (courseWorkId) {
            const courseWorksDoc = yield app_1.app.firestore.collection(`courseWorks`).doc(courseWorkId).get();
            if (courseWorksDoc.exists) {
                if (courseWorksDoc.data().assigneeMode === identifiers_1.Types.AssigneeModes.INDIVIDUAL_STUDENTS) {
                    const promise = [];
                    const studentIdValues = courseWorksDoc.data().individualStudentsOptions;
                    for (const studentIdValue of studentIdValues) {
                        promise.push(getUserDocUsingUserId(usersRef, studentIdValue));
                    }
                    const userDocs = yield Promise.all(promise);
                    return userDocs;
                }
                else {
                    return yield getUserDocUsingCourseId(usersRef, courseWorksDoc.data().courseId, role, {
                        email
                    });
                }
            }
            else {
                return [];
            }
        }
        else if (email) {
            try {
                return yield getUserDocUsingEmail(usersRef, email);
            }
            catch (e) {
                throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, 'Error fetching student info from email ' + email, e.message);
            }
        }
        else {
            return [];
        }
    });
}
exports.default = getUsers;
function getUserDocUsingEmail(usersRef, email) {
    return __awaiter(this, void 0, void 0, function* () {
        const usersDoc = yield usersRef.where('email', '==', email).get();
        if (usersDoc.size > 1) {
            console.log(`Multiple users with email ${email} found.`);
        }
        if (usersDoc.empty) {
            console.log(`No users with email ${email} found.`);
            return [];
        }
        const userDoc = usersDoc.docs[0];
        const userInfo = Object.assign({ id: userDoc.id }, userDoc.data());
        return [userInfo];
    });
}
function getUserDocUsingUserId(usersRef, userId) {
    return __awaiter(this, void 0, void 0, function* () {
        const userDoc = yield usersRef.doc(userId).get();
        return Object.assign({}, userDoc.data(), { id: userDoc.id, exists: userDoc.exists });
    });
}
function getUserDocUsingCourseId(usersRef, courseId, role, filters) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const enrollmentDocs = yield getCourseEnrollments_1.default({
                courseId,
                role
            });
            const { email } = filters;
            // get user info from users collections using array of userId
            let userDocs = [];
            console.log('enrollment docs: ', enrollmentDocs);
            for (const enrollmentDoc of enrollmentDocs) {
                const userDoc = yield getUserDocUsingUserId(usersRef, enrollmentDoc.userId);
                userDocs.push(userDoc);
            }
            if (email) {
                // check for email condition
                userDocs = userDocs.filter(userDoc => userDoc.email === email);
            }
            return userDocs;
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
//# sourceMappingURL=getUsers.js.map